import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Fragment } from 'react/jsx-runtime'
import { useTheme } from 'styled-components'

import { Padding } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { H2 } from '@/@bothrs-ui/web/components/typography/Heading'
import { StSlideGraphic, StSlideWrapper } from './UspSlide.styled'

import type { IconName } from '@fortawesome/fontawesome-svg-core'

export type Props = { title: string; message?: string; graphic: string }

const UspSlide = ({ title, message, graphic }: Props) => {
  const theme = useTheme()
  return (
    <StSlideWrapper>
      <StSlideGraphic src={graphic} />
      <H2 color={theme.Colors.Neutrals.Darkest}>{title}</H2>
      {message ? (
        <Padding px={theme.UI.Spacing.Space4}>
          <Span type='BodyLargeRegular' textAlign='center' color={theme.Colors.Neutrals.Darkest}>
            {/<fa-[\w-]+ \/>/.test(message)
              ? message.split(/<fa-[\w-]+ \/>/).map((part, index, parts) => {
                  const matches = message.match(/<fa-([\w-]+) \/>/g)
                  const iconName = matches && matches[index] ? matches[index]?.match(/fa-([\w-]+)/)?.[1] : null

                  return (
                    <Fragment key={index}>
                      {part}
                      {index < parts.length - 1 && (
                        <FontAwesomeIcon
                          fontSize='24px'
                          fontWeight={300}
                          icon={['fal', (iconName || 'circle-user') as IconName]}
                        />
                      )}
                    </Fragment>
                  )
                })
              : message}
          </Span>
        </Padding>
      ) : null}
    </StSlideWrapper>
  )
}

export { UspSlide }
